import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { CommandPalette } from '@/components/CommandPalette'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { useUIStore } from '@/stores/uiStore'
import { useSocketConnection } from '@/hooks/useSocket'
import { useRealtimeSync } from '@/hooks/useRealtimeSync'
import { useInstanceStore, isInstanceComplete } from '@/stores/instanceStore'
import { RealtimeToasts } from './RealtimeToasts'
import { cn } from '@/lib/utils'

export function MainLayout() {
  const sidebarCollapsed = useUIStore((state) => state.sidebarCollapsed)
  // Con istanza non completa (es. PROXIMA) l'assistente AI e la ricerca
  // globale (Cmd+K) non hanno senso: niente Command Palette.
  const instanceComplete = useInstanceStore((state) => isInstanceComplete(state.instance))

  // Connessione Socket.IO basata sullo stato di autenticazione
  useSocketConnection()
  // Invalidazione automatica cache React Query via eventi socket
  useRealtimeSync()

  return (
    <>
      {instanceComplete && <CommandPalette />}
      <RealtimeToasts />

      <div className="flex h-screen overflow-hidden bg-white dark:bg-slate-900">
        {/* Left sidebar navigation (desktop: pushes content; mobile: overlay) */}
        <Sidebar />

        {/* Main content area - on mobile takes full width, on desktop shifts right */}
        <div
          className={cn(
            'flex flex-col flex-1 min-w-0 transition-all duration-300 ease-in-out',
            sidebarCollapsed ? 'md:ml-16' : 'md:ml-64'
          )}
        >
          {/* Top header bar */}
          <Header />

          {/* Page content with scroll */}
          <main className="flex-1 min-h-0 overflow-y-auto bg-slate-100 dark:bg-slate-950">
            <div className="p-4 md:p-6 max-w-[1400px] mx-auto">
              <ErrorBoundary>
                <Outlet />
              </ErrorBoundary>
            </div>
          </main>
        </div>
      </div>
    </>
  )
}
